import { bl_mrp_job_template_to_process_option_process_template_link_RowClass } from '../../dbschema';
import { BaseContainerModel } from '../base-container.model';

export class MrpJobTemplateToProcessOptionProcessTemplateLinkContainerModel extends BaseContainerModel {
  bl_mrp_job_template_to_process_option_process_template_link: bl_mrp_job_template_to_process_option_process_template_link_RowClass = new bl_mrp_job_template_to_process_option_process_template_link_RowClass();
}

